import { formatDistanceStrict } from 'date-fns';
import { Model, MapTo } from 'src/app/decorators/mapto';

export class NotificationModel extends Model {
    @MapTo()
    id: number;
    @MapTo()
    to_id: string;
    @MapTo()
    from_id: number;
    @MapTo()
    object_id: string;
    @MapTo()
    object_type: string;
    @MapTo()
    message: string;
    @MapTo()
    type: string;
    @MapTo()
    is_read: number;
    @MapTo()
    status: number;
    @MapTo()
    created_at: number;
    @MapTo()
    updated_at: number;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }

    get timeAgo() {
        // TODO fix this, currently not getting notifications
        return formatDistanceStrict(new Date(), new Date(this.created_at), {
            addSuffix: true,
        });
    }

    get isRead() {
        return this.is_read;
    }
}
